<template>
  <div class="house-stat-wrapper">
    <!-- 顶部：子标签 + 状态筛选 -->
    <div class="house-stat-header">
      <div class="house-stat-tabs">
        <div
          v-for="tab in houseStatTabs"
          :key="tab.key"
          class="house-stat-tab"
          :class="{ active: houseStatActive === tab.key }"
          @click="houseStatActive = tab.key"
        >
          {{ tab.label }}
        </div>
      </div>
      <div class="house-stat-actions">
        <a-select size="small" :value="houseStatStatus" class="filter-select">
          <a-select-option value="unsold">未售</a-select-option>
          <a-select-option value="sold">已售</a-select-option>
        </a-select>
      </div>
    </div>

    <!-- 去化率 -->
    <div class="house-section">
      <div class="house-progress">
        <div class="progress-info">
          <div class="progress-title">去化率</div>
          <div class="progress-value">{{ houseSummary.depletionRate }}</div>
        </div>
        <a-progress :percent="houseSummary.depletionPercent" :show-info="false" />
      </div>
      <div class="house-summary">
        <div class="house-summary-main">
          <div class="summary-value">{{ houseSummary.totalCount }}</div>
          <div class="summary-label">合计房源数(套)</div>
          <div class="summary-sub">{{ houseSummary.totalArea }}</div>
          <div class="summary-sub">{{ houseSummary.totalAmount }}</div>
        </div>
        <div class="house-summary-list">
          <div class="house-summary-card" v-for="item in houseSummaryCards" :key="item.label">
            <div class="summary-value">{{ item.count }}</div>
            <div class="summary-label">{{ item.label }}</div>
            <div class="summary-sub">{{ item.area }}</div>
            <div class="summary-sub">{{ item.amount }}</div>
          </div>
        </div>
        <div class="house-summary-chart">
          <a-progress type="circle" :percent="houseSummary.depletionPercent" :width="80" />
        </div>
      </div>
    </div>

    <!-- 表格统计 -->
    <div class="house-section">
      <div class="house-section-title">{{ houseSectionTitle }}</div>
      <a-table
        size="small"
        :columns="houseTableColumns"
        :data-source="houseTableData"
        :pagination="false"
        row-key="key"
      />
    </div>
  </div>
</template>

<script>
export default {
  name: 'HouseStatTab',

  data() {
    return {
      houseStatActive: 'building',
      houseStatStatus: 'unsold',
      houseStatTabs: [
        { key: 'building', label: '楼栋' },
        { key: 'area', label: '产品面积' },
        { key: 'layout', label: '户型结构' }
      ],
      houseSummary: {
        depletionRate: '50%',
        depletionPercent: 50,
        totalCount: '1000',
        totalArea: '25万平米',
        totalAmount: '40000.00万元'
      },
      houseSummaryCards: [
        {
          label: '未售房源(套)',
          count: '500',
          area: '12.5万平米',
          amount: '8000.00万元'
        },
        {
          label: '已售房源(套)',
          count: '500',
          area: '12.5万平米',
          amount: '8000.00万元'
        }
      ],
      houseBuildingColumns: [
        { title: '序号', dataIndex: 'index', key: 'index' },
        { title: '楼栋', dataIndex: 'building', key: 'building' },
        { title: '房源(套)', dataIndex: 'count', key: 'count' },
        { title: '金额(万元)', dataIndex: 'amount', key: 'amount' },
        { title: '面积', dataIndex: 'area', key: 'area' }
      ],
      houseBuildingData: [
        { key: '1', index: 1, building: '1栋', count: 200, amount: 1000, area: 1111 },
        { key: '2', index: 2, building: '2栋', count: 180, amount: 1000, area: 1111 },
        { key: '3', index: 3, building: '3栋', count: 160, amount: 1000, area: 1111 }
      ],
      houseAreaColumns: [
        { title: '序号', dataIndex: 'index', key: 'index' },
        { title: '产品面积(平米)', dataIndex: 'area', key: 'area' },
        { title: '房源(套)', dataIndex: 'count', key: 'count' },
        { title: '金额(万元)', dataIndex: 'amount', key: 'amount' }
      ],
      houseAreaData: [
        { key: '1', index: 1, area: 108, count: 200, amount: 1000 },
        { key: '2', index: 2, area: 111, count: 180, amount: 1000 },
        { key: '3', index: 3, area: 120, count: 160, amount: 1000 }
      ],
      houseLayoutColumns: [
        { title: '序号', dataIndex: 'index', key: 'index' },
        { title: '户型结构', dataIndex: 'layout', key: 'layout' },
        { title: '房源(套)', dataIndex: 'count', key: 'count' },
        { title: '金额(万元)', dataIndex: 'amount', key: 'amount' }
      ],
      houseLayoutData: [
        { key: '1', index: 1, layout: '三室两厅', count: 200, amount: 1000 },
        { key: '2', index: 2, layout: '四室两厅', count: 180, amount: 1000 },
        { key: '3', index: 3, layout: '三室一厅', count: 160, amount: 1000 }
      ]
    }
  },

  computed: {
    // 表格标题根据子标签切换
    houseSectionTitle() {
      const current = this.houseStatTabs.find(item => item.key === this.houseStatActive)
      if (!current) {
        return '楼栋统计'
      }
      return `${current.label}统计`
    },
    // 表格列与数据跟随子标签切换
    houseTableColumns() {
      switch (this.houseStatActive) {
        case 'area':
          return this.houseAreaColumns
        case 'layout':
          return this.houseLayoutColumns
        default:
          return this.houseBuildingColumns
      }
    },
    houseTableData() {
      switch (this.houseStatActive) {
        case 'area':
          return this.houseAreaData
        case 'layout':
          return this.houseLayoutData
        default:
          return this.houseBuildingData
      }
    }
  }
}
</script>

<style lang="less" scoped>
.house-stat-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 12px;
}

.house-stat-tabs {
  display: flex;
  gap: 16px;
  font-size: 13px;
  color: #5b6b7c;
}

.house-stat-tab {
  padding: 4px 0;
  cursor: pointer;
  position: relative;
}

.house-stat-tab.active {
  color: #1f2f3d;
  font-weight: 600;
}

.house-stat-tab.active::after {
  content: '';
  position: absolute;
  left: 0;
  right: 0;
  bottom: -6px;
  height: 3px;
  border-radius: 2px;
  background: #2b6de5;
}

.house-stat-actions {
  display: flex;
  align-items: center;
  gap: 8px;
}

.house-section {
  background: #ffffff;
  border-radius: 10px;
  padding: 12px;
  margin-bottom: 12px;
  border: 1px solid #f0f0f0;
}

.house-progress {
  display: flex;
  align-items: center;
  gap: 12px;
  margin-bottom: 12px;
}

.progress-info {
  display: flex;
  align-items: center;
  gap: 6px;
}

.progress-title {
  font-size: 12px;
  color: #7a8699;
}

.progress-value {
  font-size: 14px;
  font-weight: 600;
  color: #1f2f3d;
}

.house-summary {
  display: grid;
  grid-template-columns: 160px 1fr 120px;
  gap: 12px;
  align-items: center;
}

.house-summary-main {
  background: #f7f9fc;
  border-radius: 10px;
  padding: 10px;
}

.summary-value {
  font-size: 18px;
  font-weight: 700;
  color: #2b6de5;
}

.summary-label {
  font-size: 12px;
  color: #7a8699;
  margin-top: 4px;
}

.summary-sub {
  color: #9aa5b1;
  font-size: 12px;
  margin-top: 4px;
}

.house-summary-list {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 10px;
}

.house-summary-card {
  background: #f7f9fc;
  border-radius: 8px;
  padding: 10px;
}

.house-summary-chart {
  text-align: center;
}

.house-section-title {
  font-weight: 600;
  color: #1f2f3d;
  margin-bottom: 10px;
}
</style>
